export default __webpack_public_path__ + "static/mast-e73e2c51ff14670032f8666ae3f358a7.mp4";